import { useEffect, useRef } from 'react';
import { Outlet } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getProductCategory, getProductPrefix, getPrivilegeLevels, getProductRefType, getProductStatus } from '@/store/slices/contentSlice';

import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import usePageTracking from '@/hooks/usePageTracking';

export default function Layout() {
	usePageTracking();

	const dispatch = useDispatch();

	const productPrefix = useSelector((state) => state.content.productPrefix);
	const productCategory = useSelector((state) => state.content.productCategory);
	const refType = useSelector((state) => state.content.refType);
	const privilegeLevels = useSelector((state) => state.content.privilegeLevels);
	const projectStatus = useSelector((state) => state.content.projectStatus);

	const observedElementRef = useRef(null);

	useEffect(() => {
		if (!productPrefix) {
			dispatch(getProductPrefix({ max_size: true }));
		}
	}, [productPrefix, dispatch]);

	useEffect(() => {
		if (!productCategory) {
			dispatch(getProductCategory({ order_by:'categoryname', max_size: true, status: 1 }));
		}
	}, [productCategory, dispatch]);

	useEffect(() => {
		if (!refType) {
			dispatch(getProductRefType({ max_size: true }));
		}
	}, [refType, dispatch]);

	useEffect(() => {
		if (!privilegeLevels) {
			dispatch(getPrivilegeLevels({ max_size: true }));
		}
	}, [privilegeLevels, dispatch]);

	useEffect(() => {
		if (!projectStatus) {
			dispatch(getProductStatus({ order_by: 'id', max_size: true }));
		}
	}, [projectStatus, dispatch]);

	return (
		<div ref={observedElementRef} className='layout'>
			<Header />
			<div className='flex flex-1 h-full bg-bd-bg'>
				<Outlet />
			</div>
			<Footer />
		</div>
	);
}
